import { useState, FC } from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { useForm } from '@carcareers/contexts';
import { Payment } from '@carcareers/components';

interface PaymentInputProps {
  namePaymentProfileId: string;
  nameTotalPaymentDue: string;
  label?: string;
} 

export const PaymentInput: FC<PaymentInputProps> = ({ namePaymentProfileId, nameTotalPaymentDue, label }) => {
  const { setData, getErrors } = useForm();
  const [totalPaymentDue, setTotalPaymentDue] = useState<string>('');


  const handleTotalPaymentDueChange = (value: string) => {
    const parts = value.split('.');
    if (parts[1]?.length > 2) {
      parts[1] = parts[1].slice(0, 2);
      value = parts.join('.');
    }

    setTotalPaymentDue(value);
    setData(nameTotalPaymentDue, Number(value));
  };

  return (
    <>
      <TextField 
        label={label}
        value={totalPaymentDue}
        onChange={(e) => handleTotalPaymentDueChange(e.target.value)}
        error={!!getErrors(nameTotalPaymentDue)}
        helperText={getErrors(nameTotalPaymentDue)}
        slotProps={{
          input: {
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          },
        }}
      />
      <Payment isInput onClick={(paymentId) => setData(namePaymentProfileId, Number(paymentId))} />
    </>
  );
};

export default PaymentInput;
